const config = {
  apiUrl: "https://riberauth.3rribersolo.com.br",
  aclUrl: "https://aclultrasolo.3rribersolo.com.br",
  backendUrl: "https://sample.3rribersolo.com.br",
};

// const config = {
//   apiUrl: "https://riberauth.dev.3rribersolo.com.br",
//   aclUrl: "https://aclultrasolo.dev.3rribersolo.com.br",
//   backendUrl: "https://sample.dev.3rribersolo.com.br",
// };

// const config = {
//   apiUrl: "http://localhost:8000",
//   aclUrl: "http://localhost:8001",
//   backendUrl: "http://localhost:8002",
// };

export default config;  